<template>
    <div id="app">
        <router-view />
        <Loading v-if="loading"></Loading>
        <ScheduledRemindersPopup></ScheduledRemindersPopup>
    </div>
</template>
<script>
import ScheduledRemindersPopup from '@/components/ScheduledRemindersPopup/ScheduledRemindersPopup';
import Loading from '@/components/utils/Loading/Loading';
import GlobalMixin from '@/mixins/global';
import { mapState } from 'vuex';

export default {
    components: { ScheduledRemindersPopup, Loading },
    mixins: [GlobalMixin],
    computed: {
        ...mapState('loading', ['loading']),
    },
};
</script>
